import React from 'react'
import Slider from "react-slick";
import ChatNow from "../chatnow"

const Stories = () => {
    const slider = React.useRef(null);
    var settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                }
            }
        ]
    };


    return (
        <div className='min-h-screen py-12 bg-primary relative' id='stories'>
            <div className='container mx-auto'>
                <p className='text-center text-white'>
                    Success Stories
                </p>

                <h2 className='text-center text-white text-5xl md:text-6xl font-bold mt-5 max-w-[850px] mx-auto'>
                    Our Legal Team Has Recovered Millions
                </h2>
                <div className='my-16 mx-5 relative'>
                    <button className='absolute z-10 -left-5 md:-left-8 top-1/3' onClick={() => slider?.current?.slickPrev()} >
                        <img src='/assets/images/arrow-left.png' alt="" className='w-20 h-20' />
                    </button>
                    <div className=''>
                        <Slider {...settings} ref={slider}>
                            <div className='p-2'>
                                <div className='bg-white rounded-md p-6'>
                                    <div className='flex gap-2'>
                                        <span className='text-3xl'>$</span>  <p className='font-bold text-6xl'>1.95 M</p>
                                    </div>
                                    <p className='mt-28 mb-14'>Id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio.</p>
                                    <a href='/' className=' flex items-center gap-2' >
                                        <p className='border-b border-black'>Learn More</p>
                                        <img src="/assets/images/arrow-2-right.png" alt='' />
                                    </a>
                                </div>
                            </div>
                            <div className='p-2'>
                                <div className='bg-white rounded-md p-6'>
                                    <div className='flex gap-2'>
                                        <span className='text-3xl'>$</span>  <p className='font-bold text-6xl'>4.5 M</p>
                                    </div>
                                    <p className='mt-28 mb-14'>Id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio.</p>
                                    <a href='/' className=' flex items-center gap-2' >
                                        <p className='border-b border-black'>Learn More</p>
                                        <img src="/assets/images/arrow-2-right.png" alt='' />
                                    </a>
                                </div>
                            </div>
                            <div className='p-2'>
                                <div className='bg-white rounded-md p-6'>
                                    <div className='flex gap-2'>
                                        <span className='text-3xl'>$</span>  <p className='font-bold text-6xl'>1.95 M</p>
                                    </div>
                                    <p className='mt-28 mb-14'>Id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio.</p>
                                    <a href='/' className=' flex items-center gap-2' >
                                        <p className='border-b border-black'>Learn More</p>
                                        <img src="/assets/images/arrow-2-right.png" alt='' />
                                    </a>
                                </div>
                            </div>
                            <div className='p-2'>
                                <div className='bg-white rounded-md p-6'>
                                    <div className='flex gap-2'>
                                        <span className='text-3xl'>$</span>  <p className='font-bold text-6xl'>4.5 M</p>
                                    </div>
                                    <p className='mt-28 mb-14'>Id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio.</p>
                                    <a href='/' className=' flex items-center gap-2' >
                                        <p className='border-b border-black'>Learn More</p>
                                        <img src="/assets/images/arrow-2-right.png" alt='' />
                                    </a>
                                </div>
                            </div>
                        </Slider>
                    </div>
                    <button onClick={() => slider?.current?.slickNext()} className='absolute -right-5 md:-right-8 top-1/3 '>
                        <img src='/assets/images/arrow-right.png' alt="" className='w-20 h-20' />
                    </button>
                </div>

            </div>
            <div className='absolute max-sm:left-0 right-0 bottom-2 sm:right-14 p-4'>
                <ChatNow variant="white" text="Chat now!" />
            </div>
        </div>
    )
}

export default Stories